import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/../Assets/Yousef-to-job-cv.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { SiCodereview } from "react-icons/si";//view icon
import { SiGmail } from "react-icons/si";//gmail icon
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);
  
  const gmailAddress = 'yousefghanem.linkedin@gmail.com';
  
  // Gmail compose mail URL
  const mailtoLink = `mailto:${gmailAddress}`
  const openGmail = () => {
    window.location.href = `mailto:${gmailAddress}`;
  };
  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />{/*Disable Particle if you wanna use button*/}
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <SiCodereview />
            &nbsp;View CV
          </Button>
        </Row>

        <Row className="resume">
          <Document file={pdf} className="d-flex justify-content-center">
            <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
          </Document>
        </Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            download="Yousef-Ghanem-Resume.pdf"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
          
        </Row>
        <Row style={{ justifyContent: "center", marginTop:"10px", position: "relative" }}>
        <Button
            onClick={openGmail}
            variant="primary"
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <SiGmail />
            &nbsp;Contact Now
        </Button>
        </Row>

      </Container>
    </div>
  );
}

export default ResumeNew;
